import { render } from "./modal-add-pertanyaan.vue?vue&type=template&id=e222055c&scoped=true"
import script from "./modal-add-pertanyaan.vue?vue&type=script&lang=js"
export * from "./modal-add-pertanyaan.vue?vue&type=script&lang=js"

import "./modal-add-pertanyaan.vue?vue&type=style&index=0&id=e222055c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e222055c"]])

export default __exports__